import React from "react";
import Modal from "react-bootstrap/Modal"
import {connect} from "react-redux";
import {AppState} from "../RootReducer";
import {Dispatch} from "redux";
import {showCashier} from "../payments/DepositActions";
import StorePage from "../storepage/StorePage";
import {ContentModelName, GlobalPayload} from "../contenful/types";
import {fetchContent} from "../contenful/ContentfulActions";
import {KycStatus, PaymentMethod, Settings, UserInfo} from "../http/protocol";
import "./styles/CashierModal.scss";
import {selectBundle} from "../store/StoreActions";
import Withdraw from "./Withdraw";
import {LoginStatus} from "../http/Types";
import ProfileMetamapComponent from "../profilepage/ProfileMetamapComponent";
import {fetchSettings} from "../settings/SettingsActions";
import Deposit from "../onboardingpage/Deposit";
import {getContainer} from "../ioc/IOCSetup";
import {fetchUserInfo, setActiveCurrency} from "../user/UserActions";
import {CashierSection, DepositState, WithdrawState} from "../payments/PaymentsReducer";
import BuyCrypto from "./BuyCrypto";
import Tabbar from "./navigation/Tabbar";
import {MenuCloseButton} from "./navigation/Menu";
import {fetchProviders} from "../payments/PaymentsActions";
import TipPlayer from "./TipPlayer";
import { t } from "../i18n";
import GlifeContextWithdraw from "../glife/GlifeContextWithdraw";


type AllProps = PropsFromState & PropsFromDispatch;


export class CashierModal extends React.Component<AllProps> {

    constructor(props : AllProps) {
        super(props);
    }

    componentDidMount(): void {
        window.addEventListener("message", this.handleMessage, false);
        if(!this.props.withdraw?.methods) {
            this.props.fetchProviders?.();
        }
        if(!this.props.isFetching) {
            if(this.props.error === undefined) {
                if(this.props.global == undefined) {
                    this.props.fetchContent(ContentModelName.GLOBAL, this.props.lng);
                }
            }
        }

        if(this.props.user === undefined) {
            this.props.hide&& this.props.hide();
        }

        if(!this.props.loggedIn) {
            this.props.hide&& this.props.hide();
        }

        if(this.props.settings === undefined) {
            this.props.fetchSettings();
        }

    }

    componentDidUpdate(prevProps: AllProps): void {
        if(this.props.show !== prevProps.show) {
            if(!this.props.show) {
                this.postEventToPoker();
            }
        }

        const kycOnDepositOrWithdrawalRequired = this.props.settings?.kycOnDepositRequired || this.props.settings?.kycOnWithdrawRequired
        const fromHiddenToShowing = !prevProps.show  &&  this.props.show

        if (fromHiddenToShowing  &&  kycOnDepositOrWithdrawalRequired) {
            this.props.fetchUserInfo()
        }
    }

    postEventToPoker = () => {
        let iframe: any = document.getElementById("poker-iframe");
        if(iframe !== null) {
            iframe.contentWindow.postMessage({ action: "reloadProfile" }, "*");
        }
    }

    handleMessage = (event: any) => {
        if(event.data && event.data.currencyCode) {
            this.props.user && this.props.user.currencies && this.props.user.currencies.filter((cur) => {
                if(event.data.currencyCode == cur.code) {
                    setActiveCurrency(event.data.currencyCode)
                }
            })
        }
        if(event.data&& event.data.action === "cashierOpenRequested") {
            if(this.props.loggedIn) {
                this.props.showCashier && this.props.showCashier();
            }
        }
    }

    handleGoBack = () => {
        this.props.hide&& this.props.hide();
    };




    render() {

        let props = this.props;
        let activeTab = this.props.activeTab;
        let useStore = props.settings && props.settings.useStoreInsteadOfDeposit;
        let kycOnWithdrawRequired = props.settings && props.settings.kycOnWithdrawRequired && props.user && props.user.kycStatus != KycStatus.VERIFIED
        let kycOnDepositRequired = props.settings && props.settings.kycOnDepositRequired && props.user && props.user.kycStatus != KycStatus.VERIFIED
        let matiEnabled = props.settings?.matiEnabled;
        const showKycButton = () => {
            if(activeTab === CashierSection.WITHDRAW && kycOnWithdrawRequired && matiEnabled) {
                return true;
            } else if(activeTab === CashierSection.DEPOSIT && kycOnDepositRequired && matiEnabled) {
                return true;
            }
            return false;
        }
        return (
          <Modal size="lg" aria-labelledby="contained-modal-title-vcenter" show={props.show} dialogClassName={this.props.mobile ? "cashier-mobile-modal" : "cashier-modal"} onHide={() => props.hide && props.hide()}>
            <Modal.Header>
              <div className={"menu-close"} onClick={() => props.hide?.()}>
                <MenuCloseButton />
              </div>
            </Modal.Header>
            <Modal.Body>
              <Tabbar loading={false} />
              <div className="methodContainer">
                <div className={"deposit-wrapper method"}>
                  <div className="content-wrapper">
                    {activeTab === CashierSection.DEPOSIT && !kycOnDepositRequired && <Deposit />}
                    {activeTab === CashierSection.DEPOSIT && useStore && <StorePage />}
                    {activeTab === CashierSection.WITHDRAW && !kycOnWithdrawRequired && (
                      <GlifeContextWithdraw>
                        <Withdraw />
                      </GlifeContextWithdraw>
                    )}
                    {activeTab === CashierSection.WITHDRAW && kycOnWithdrawRequired && (
                      <GlifeContextWithdraw>
                        <div className={"alert alert-danger"}>{t("payments.withdrawal-kyc-required")}</div>
                      </GlifeContextWithdraw>
                    )}
                    {activeTab === CashierSection.DEPOSIT && kycOnDepositRequired && <div className={"alert alert-danger"}>{t("payments.deposit-kyc-required")}</div>}
                    {showKycButton() && (
                      <>
                        <ProfileMetamapComponent />
                        <div className={"addMargin"}></div>
                      </>
                    )}
                    {activeTab === CashierSection.BUY_CRYPTO && <BuyCrypto />}
                    {activeTab === CashierSection.TIP && this.props.settings?.tippingEnabled && (
                      <GlifeContextWithdraw>
                        <TipPlayer onClick={() => props.hide && props.hide()} />
                      </GlifeContextWithdraw>
                    )}
                  </div>
                </div>
              </div>
            </Modal.Body>
          </Modal>
        );
    }
}

interface PropsFromState {
    show?: boolean,
    useAsStore?: boolean;
    global?:GlobalPayload;
    settings?: Settings;
    selectedBundleId?: number;
    user?: UserInfo;
    loggedIn: boolean;
    activeTab?: CashierSection;
    lng: string;
    isFetching?:boolean;
    error?:any;
    mobile? : boolean;
    deposit? : DepositState;
}

const mapStateToProps = (state : AppState) => {

    return    {
        show : state.payments.cashier.showCashierModal,
        useAsStore : state.payments.deposit.useAsStore,
        global: state.contentful.global,
        error: state.contentful.error,
        isFetching: state.contentful.isFetching,
        settings: state.settings.settings,
        selectedBundleId: state.store.selectedBundleId,
        user: state.user.user,
        loggedIn : LoginStatus.LOGGED_IN == state.user.status,
        activeTab: state.payments.cashier.section,
        lng: getContainer().getSettingsService().getActiveLocale().code,
        mobile : state.settings.mobile,
        deposit : state.payments.deposit,
        withdraw : state.payments.withdraw
    }
}


interface PropsFromDispatch {
    hide?: ()=>void;
    fetchContent: typeof fetchContent;
    selectBundle: typeof selectBundle;
    showCashier? : () => void;
    fetchSettings : typeof fetchSettings;
    choosePaymentMethod? : (m : PaymentMethod)=> void;
    withdraw? : WithdrawState;
    fetchProviders : typeof fetchProviders;
    fetchUserInfo : typeof fetchUserInfo;
}

const mapDispatchToProps = (dispatch : Dispatch) => (
    {
        hide : () => dispatch(showCashier(false, CashierSection.NONE)),
        fetchContent : (contentModelName: ContentModelName, locale?: string) => dispatch(fetchContent(contentModelName, locale) as any),
        selectBundle: (bundleId?: number) => dispatch(selectBundle(bundleId) as any),
        showCashier : () => dispatch(showCashier(true)),
        fetchSettings : () => dispatch(fetchSettings() as any),
        fetchProviders : () => dispatch(fetchProviders() as any),
        fetchUserInfo : () => dispatch(fetchUserInfo(false) as any)
    }
)

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CashierModal as any);

